import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getAddressConfirmations } from '../../api/address-confirmations';
import { enqueueSnackbarAction } from '../notifications/actions';
import {
    FETCH_ADDRESS_CONFIRMATIONS,
    requestFetchAddressConfirmations,
    requestFetchAddressConfirmationsFailure,
    requestFetchAddressConfirmationsSuccess,
} from './actions';

function* fetchAddressConfirmationsSaga(action: AnyAction): SagaIterator {
    yield put(requestFetchAddressConfirmations());

    const { error, response } = yield call(getAddressConfirmations, action.pageable);

    if (error) {
        yield put(
            enqueueSnackbarAction({
                message: 'Fehler: Address Bestätigungen konnten nicht geladen werden!' + error.message,
                options: {
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                },
            })
        );
        yield put(requestFetchAddressConfirmationsFailure(error));
    } else {
        // yield put(
        //     enqueueSnackbarAction({
        //         message: response.statusText || 'Address Bestätigungen erfolgreich geladen',
        //         options: {
        //             key: new Date().getTime() + Math.random(),
        //             variant: 'success',
        //         },
        //     })
        // );
        yield put(requestFetchAddressConfirmationsSuccess(response));
    }
}

export function* generateFetchAddressConfirmationsWatcher() {
    yield takeLatest(FETCH_ADDRESS_CONFIRMATIONS, fetchAddressConfirmationsSaga);
}
